import { registerPlugin } from '@capacitor/core';
const CapacitorScrollSwipeBounceIos = registerPlugin('CapacitorScrollSwipeBounceIos', {
    web: () => import('./web').then(m => new m.CapacitorScrollSwipeBounceIosWeb()),
});
export * from './definitions';
export { CapacitorScrollSwipeBounceIos };
//# sourceMappingURL=index.js.map